import React, { useContext } from 'react'
import { ControlDark } from '@fs/zion-icon'
import { Toggle, Divider, Separator } from '@fs/zion-ui'
import { useFeatureFlag } from '@fs/zion-flags'
import { useTranslation } from 'react-i18next'
import { DarkModeContext } from '../../providers/darkModeProvider/DarkModeProvider'

const DARK_MODE_FEATURE_FLAG = 'rip_sharedImageViewer_darkMode'

export default function DarkModeControl() {
  const { isOn: isDarkModeFeatureEnabled } = useFeatureFlag(DARK_MODE_FEATURE_FLAG)
  const [t] = useTranslation()
  const { isDarkModeOn, setIsDarkModeOn, loading } = useContext(DarkModeContext)

  if (!isDarkModeFeatureEnabled) return null

  const handleChange = ({ target: { checked } }) => {
    setIsDarkModeOn(checked)
  }

  return (
    <>
      <Divider label={t('film-viewer.toggle-dark-mode.label', 'Toggle Dark Mode')} fullWidth />
      <Separator size="xxs" />
      <Toggle
        disabled={loading}
        label={
          <>
            <ControlDark /> {t('shared-image-viewer.darkMode', 'Dark Mode')}
          </>
        }
        allowLabelWrapping
        name="darkMode"
        checked={loading ? false : isDarkModeOn}
        onChange={handleChange}
        data-testid="dark-mode-toggle"
      />
    </>
  )
}
